import { FC, useState } from 'react'
import { IonButton, IonIcon, useIonToast } from '@ionic/react'
import { add } from 'ionicons/icons'
import { ClinicReception, Reception } from '../../../API'
import ReceptionSelect from '../../../components/select/ReceptionSelect'
import { ClinicReceptionService } from '../../../components/services/ClinicReceptionService'
import { TbnResponse } from '../../../components/services/TbnResponse'
import { failure, success } from '../../../components/util/Toast'
import { isMobile } from '../../../components/util/isMobile'

interface ClinicReceptionAddButtonProps {
  clinicID: string
  onSuccess: Function
}
const ClinicReceptionAddButton: FC<ClinicReceptionAddButtonProps> = ({ clinicID, onSuccess }) => {
  const [selected, setSelected] = useState<Reception>()
  const [model] = useState<ClinicReception>({
    clinicID,
  } as ClinicReception)
  const [adding, setAdding] = useState(false)
  const [presentToast] = useIonToast()

  const addItem = async () => {
    setAdding(true)
    if (!!selected) {
      const res: TbnResponse = await ClinicReceptionService.Instance.store({ ...model, receptionID: selected.id })
      if (res.data) {
        success('Success adding new reception to the clinic', presentToast)
        onSuccess(res.data)
      } else if (res.errorMessage) {
        failure(res.errorMessage, presentToast)
      }
    }
    setAdding(false)
  }

  return (
    <div className='flex-container flex-space-between align-items-center'>
      <div style={{ width: '90%' }}>
        <ReceptionSelect onChange={(itm: Reception) => setSelected(itm)} />
      </div>
      <IonButton
        onClick={addItem}
        disabled={!selected || adding}
        className='ion-float-end'
        size={isMobile() ? 'small' : 'default'}
      >
        <IonIcon icon={add} slot='icon-only' />
      </IonButton>
    </div>
  )
}

export default ClinicReceptionAddButton
